import TypeaheadDropdown from './typeahead-dropdown-component';
import TypeaheadDropdownRequired from './typeahead-dropdown-require';
import TypeaheadDropdownInfiniteScroll from './typeahead-dropdown-infinite-scroll';
import './typeahead-dropdown.scss';
import KtTooltipEnableOnEllipsis from './ktTooltipEnableOnEllipsis.directive';

const MODULE_NAME = 'app.common.typeahead-dropdown';
const module = angular.module(MODULE_NAME, [])
    .directive(TypeaheadDropdown.DIRECTIVE_NAME, TypeaheadDropdown)
    .directive('ktTooltipEnableOnEllipsis', KtTooltipEnableOnEllipsis)
    .directive('ktTypeaheadDropdownRequired', TypeaheadDropdownRequired)
    .directive('ktTypeaheadDropdownInfiniteScroll', TypeaheadDropdownInfiniteScroll);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/typeahead-dropdown/typeahead-dropdown-module.js